export default "__VITE_PUBLIC_ASSET__2ee8edfc__"